import { useState } from "react";
import {
    Scheduler,
    WeekView,
    DayView,
    Appointments,
    Toolbar,
    DateNavigator,
    ViewSwitcher,
    AllDayPanel,
    AppointmentTooltip,
    AppointmentForm,
    GroupingPanel,
    Resources,
  } from '@devexpress/dx-react-scheduler-material-ui';
// import PriorityHigh from '@mui/icons-material/PriorityHigh';
// import LowPriority from '@mui/icons-material/LowPriority';
import Lens from '@mui/icons-material/Lens';
import Event from '@mui/icons-material/Event';
import AccessTime from '@mui/icons-material/AccessTime';
import { alpha, Button, Fab, FormControl, Grid, IconButton, MenuItem, Select, styled, TextField } from "@mui/material";
import { PriorityHigh, LowPriority, Edit, Delete, Close, CalendarToday, Create, LocationOn, Add as AddIcon, Notes } from '@mui/icons-material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import classNames from 'clsx';
import UserImage from "../../../components/UserImage";
import Image from 'react-bootstrap/Image';
import { useTranslation } from "react-i18next";
import { PUBLIC_ID } from "../../../config";
import useHelperService from '../../services/HelperService';

const useSchedulerItems = (priorities: any[]) => {
    const { t } = useTranslation();
    // SERVICES
    const {truncate} = useHelperService();
        
    const getIconById = (id: number) => {
        // if (id === 1) {
        //   return LowPriority;
        // }
        // if (id === 2) {
        //   return Event;
        // }
        // if (id === 4) {
        //   return LowPriority;
        // }
        // return PriorityHigh;
        return Event;
    };
    
    const PREFIX = 'Schedulum';
    // #FOLD_BLOCK
    const classes = {
        flexibleSpace: `${PREFIX}-flexibleSpace`,
        prioritySelector: `${PREFIX}-prioritySelector`,
        content: `${PREFIX}-content`,
        contentContainer: `${PREFIX}-contentContainer`,
        text: `${PREFIX}-text`,
        title: `${PREFIX}-title`,
        icon: `${PREFIX}-icon`,
        contentItemIcon: `${PREFIX}-contentItemIcon`,
        grayIcon: `${PREFIX}-grayIcon`,
        colorfulContent: `${PREFIX}-colorfulContent`,
        lens: `${PREFIX}-lens`,
        textCenter: `${PREFIX}-textCenter`,
        dateAndTitle: `${PREFIX}-dateAndTitle`,
        titleContainer: `${PREFIX}-titleContainer`,
        container: `${PREFIX}-container`,
        bullet: `${PREFIX}-bullet`,
        prioritySelectorItem: `${PREFIX}-prioritySelectorItem`,
        priorityText: `${PREFIX}-priorityText`,
        priorityShortText: `${PREFIX}-priorityShortText`,
        cellLowPriority: `${PREFIX}-cellLowPriority`,
        cellMediumPriority: `${PREFIX}-cellMediumPriority`,
        cellHighPriority: `${PREFIX}-cellHighPriority`,
        headerCellLowPriority: `${PREFIX}-headerCellLowPriority`,
        headerCellMediumPriority: `${PREFIX}-headerCellMediumPriority`,
        headerCellHighPriority: `${PREFIX}-headerCellHighPriority`,

        // content: `${PREFIX}-content`,
        header: `${PREFIX}-header`,
        closeButton: `${PREFIX}-closeButton`,
        buttonGroup: `${PREFIX}-buttonGroup`,
        button: `${PREFIX}-button`,
        picker: `${PREFIX}-picker`,
        wrapper: `${PREFIX}-wrapper`,
        // icon: `${PREFIX}-icon`,
        textField: `${PREFIX}-textField`,
        addButton: `${PREFIX}-addButton`,
    };
    // #FOLD_BLOCK
    const stylesByPriority = priorities.reduce((acc: any, priority: any) => ({
        ...acc,
        [`cell${priority.text.replace(' ', '')}`]: {
            backgroundColor: alpha(priority.color[400], 0.1),
            '&:hover': {
            backgroundColor: alpha(priority.color[400], 0.15),
            },
            '&:focus': {
            backgroundColor: alpha(priority.color[400], 0.2),
            },
        },
        [`headerCell${priority.text.replace(' ', '')}`]: {
            backgroundColor: alpha(priority.color[400], 0.1),
            '&:hover': {
            backgroundColor: alpha(priority.color[400], 0.1),
            },
            '&:focus': {
            backgroundColor: alpha(priority.color[400], 0.1),
            },
        },
    }), {});
    // #FOLD_BLOCK
    const groupingStyles = ({ theme }: any) => ({
        [`&.${classes.cellLowPriority}`]: stylesByPriority.cellLowPriority,
        [`&.${classes.cellMediumPriority}`]: stylesByPriority.cellMediumPriority,
        [`&.${classes.cellHighPriority}`]: stylesByPriority.cellHighPriority,
        [`&.${classes.headerCellLowPriority}`]: stylesByPriority.headerCellLowPriority,
        [`&.${classes.headerCellMediumPriority}`]: stylesByPriority.headerCellMediumPriority,
        [`&.${classes.headerCellHighPriority}`]: stylesByPriority.headerCellHighPriority,
        [`& .${classes.icon}`]: {
            paddingLeft: theme.spacing(1),
            verticalAlign: 'middle',
        },
    });

    // #FOLD_BLOCK
    const StyledToolbarFlexibleSpace = styled(Toolbar.FlexibleSpace)(() => ({
        [`&.${classes.flexibleSpace}`]: {
            margin: '0 auto 0 0',
        },
    }));

    const StyledFormControl = styled(FormControl)(({ theme: { spacing } }: any) => ({
        [`&.${classes.prioritySelector}`]: {
            minWidth: 140,
            marginLeft: spacing(2),
            '@media (max-width: 500px)': {
            minWidth: 0,
            fontSize: '0.75rem',
            marginLeft: spacing(0.5),
            },
        },
    }));

    // #FOLD_BLOCK
    const StyledPrioritySelectorItem = styled('div')(({ theme: { palette, spacing }, color }: any) => ({
        [`& .${classes.bullet}`]: {
            backgroundColor: color ? color[400] : palette.divider,
            borderRadius: '50%',
            width: spacing(2),
            height: spacing(2),
            marginRight: spacing(2),
            display: 'inline-block',
        },
        [`&.${classes.prioritySelectorItem}`]: {
            display: 'flex',
            alignItems: 'center',
        },
        [`& .${classes.priorityText}`]: {
            '@media (max-width: 500px)': {
            display: 'none',
            },
        },
        [`& .${classes.priorityShortText}`]: {
            '@media (min-width: 500px)': {
            display: 'none',
            },
        },
    }));
    // #FOLD_BLOCK
    const StyledWeekViewTimeTableCell = styled(WeekView.TimeTableCell)(groupingStyles);
    // #FOLD_BLOCK
    const StyledTooltipContent = styled('div')(({ theme: { spacing, typography, palette }, color }: any) => ({
        [`&.${classes.content}`]: {
            padding: spacing(3, 1),
            paddingTop: 0,
            backgroundColor: palette.background.paper,
            boxSizing: 'border-box',
            width: '400px',
        },
        [`& .${classes.contentContainer}`]: {
            paddingBottom: spacing(1.5),
        },
        [`& .${classes.text}`]: {
            ...typography.body2,
            display: 'inline-block',
        },
        [`& .${classes.title}`]: {
            ...typography.h6,
            color: palette.text.secondary,
            fontWeight: typography.fontWeightBold,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
        },
        [`& .${classes.icon}`]: {
            verticalAlign: 'middle',
        },
        [`& .${classes.contentItemIcon}`]: {
            textAlign: 'center',
        },
        [`& .${classes.grayIcon}`]: {
            color: palette.action.active,
        },
        [`& .${classes.colorfulContent}`]: {
            color: color[300],
        },
        [`& .${classes.lens}`]: {
            width: spacing(4.5),
            height: spacing(4.5),
            verticalAlign: 'super',
        },
        [`& .${classes.textCenter}`]: {
            textAlign: 'center',
        },
        [`& .${classes.dateAndTitle}`]: {
            lineHeight: 1.1,
        },
        [`& .${classes.titleContainer}`]: {
            paddingBottom: spacing(2),
        },
        [`& .${classes.container}`]: {
            paddingBottom: spacing(1.5),
        },
    }));

    const StyledTooltipHeader = styled('div')(({ theme }) => ({
        [`& .${classes.icon}`]: {
          margin: theme.spacing(2, 0),
          marginRight: theme.spacing(2),
        },
        [`& .${classes.header}`]: {
          overflow: 'hidden',
          marginTop: theme.spacing(1),
          paddingTop: theme.spacing(0.5),
        },
        [`& .${classes.textField}`]: {
          width: '100%',
        },
        [`& .${classes.content}`]: {
          padding: theme.spacing(2),
          paddingTop: 0,
        },
        [`& .${classes.closeButton}`]: {
          float: 'right',
        },
        [`& .${classes.picker}`]: {
          marginRight: theme.spacing(2),
          '&:last-child': {
            marginRight: 0,
          },
          width: '50%',
        },
        [`& .${classes.wrapper}`]: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: theme.spacing(1, 0),
        },
        [`& .${classes.buttonGroup}`]: {
          display: 'flex',
          justifyContent: 'flex-end',
          padding: theme.spacing(0, 2),
        },
        [`& .${classes.button}`]: {
          marginLeft: theme.spacing(2),
        },
    }));

    // #FOLD_BLOCK
    const StyledDayViewDayScaleCell = styled(DayView.DayScaleCell)(groupingStyles);

    const StyledWeekViewDayScaleCell = styled(WeekView.DayScaleCell)(groupingStyles);

    const StyledAllDayPanelCell = styled(AllDayPanel.Cell)(groupingStyles);

    const StyledGroupingPanelCell = styled(GroupingPanel.Cell)(groupingStyles);

    const StyledDayViewTimeTableCell = styled(DayView.TimeTableCell)(groupingStyles);

    const DayViewTimeTableCell = ({
        groupingInfo, ...restProps
    }: any) => {
        const groupId = groupingInfo[0].id;
        return (
        <StyledDayViewTimeTableCell
            className={classNames({
            [classes.cellLowPriority]: groupId === 1,
            [classes.cellMediumPriority]: groupId === 2,
            [classes.cellHighPriority]: groupId === 3,
            })}
            groupingInfo={groupingInfo}
            {...restProps}
        />
        );
    };
    // #FOLD_BLOCK
    const DayViewDayScaleCell = ({
        groupingInfo, ...restProps
    // #FOLD_BLOCK
    }: any) => {
        const groupId = groupingInfo[0].id;
        return (
        <StyledDayViewDayScaleCell
            className={classNames({
            [classes.headerCellLowPriority]: groupId === 1,
            [classes.headerCellMediumPriority]: groupId === 2,
            [classes.headerCellHighPriority]: groupId === 3,
            })}
            groupingInfo={groupingInfo}
            {...restProps}
        />
        );
    };
    // #FOLD_BLOCK
    const WeekViewTimeTableCell = ({
        groupingInfo, ...restProps
    // #FOLD_BLOCK
    }: any) => {
        const groupId = groupingInfo[0].id;
        return (
        <StyledWeekViewTimeTableCell
            className={classNames({
            [classes.cellLowPriority]: groupId === 1,
            [classes.cellMediumPriority]: groupId === 2,
            [classes.cellHighPriority]: groupId === 3,
            })}
            groupingInfo={groupingInfo}
            {...restProps}
        />
        );
    };
    // #FOLD_BLOCK
    const WeekViewDayScaleCell = ({
        groupingInfo, ...restProps
    // #FOLD_BLOCK
    }: any) => {
        const groupId = groupingInfo[0].id;
        return (
        <StyledWeekViewDayScaleCell
            className={classNames({
            [classes.headerCellLowPriority]: groupId === 1,
            [classes.headerCellMediumPriority]: groupId === 2,
            [classes.headerCellHighPriority]: groupId === 3,
            })}
            groupingInfo={groupingInfo}
            {...restProps}
        />
        );
    };
    // #FOLD_BLOCK
    const AllDayCell = ({
        groupingInfo, ...restProps
    // #FOLD_BLOCK
    }: any) => {
        const groupId = groupingInfo[0].id;
        return (
        <StyledAllDayPanelCell
            className={classNames({
            [classes.cellLowPriority]: groupId === 1,
            [classes.cellMediumPriority]: groupId === 2,
            [classes.cellHighPriority]: groupId === 3,
            })}
            groupingInfo={groupingInfo}
            {...restProps}
        />
        );
    };
    // #FOLD_BLOCK
    const GroupingPanelCell = ({
        group, ...restProps
    // #FOLD_BLOCK
    }: any) => {
        const groupId = group.id;
        const Icon = getIconById(groupId);
        // console.log(group);
        return (
        <StyledGroupingPanelCell
            className={classNames({
            [classes.headerCellLowPriority]: groupId === 1,
            [classes.headerCellMediumPriority]: groupId === 2,
            [classes.headerCellHighPriority]: groupId === 3,
            })}
            group={group}
            {...restProps}
        >
            <Icon
            className={classes.icon}
            />
        </StyledGroupingPanelCell>
        );
    };
    // #FOLD_BLOCK
    const PrioritySelectorItem = ({
        color, text: resourceTitle,
    }: any) => {
        const text = resourceTitle || t('scheduler.all_shifts');
        // const text = resourceTitle == t('scheduler.all_users') ? truncate(t('scheduler.all_users'), 5) : resourceTitle;
        // const shortText = resourceTitle || t('scheduler.all_users');
        const shortText = resourceTitle ? resourceTitle == t('scheduler.all_shifts') ?  truncate(text, 5) : truncate(text, 14) : t('scheduler.all_shifts');
        //text.substring(0, 15) + "..." : t('scheduler.all_users_short');
    
        return (
        <StyledPrioritySelectorItem className={classes.prioritySelectorItem} color={color}>
            <span className={classes.bullet} />
            <span className={classes.priorityText}>{text}</span>
            {/* <span className={classes.priorityShortText}>{text}</span> */}
            <span className={classes.priorityShortText} >{shortText}</span>
        </StyledPrioritySelectorItem>
        );
    };
    
    const PrioritySelector = ({
        priorityChange, priority,
    }: any) => {
        // alert(priority);
    //   const currentPriority = priority > 0 ? priorities[priority - 1] : {};
        // const currentPriority = priority > 0 ? priorities[priority - 1] : { text: 'All Users', color: {} };
        const currentPriority = priority != 0 ? priorities.find(p => p.id === priority) : { text: t('scheduler.all_shifts'), color: {} };

        return (
        <StyledFormControl className={classes.prioritySelector} variant="standard">
            <Select
            disableUnderline
            value={priority}
            onChange={(e) => {
                priorityChange(e.target.value);
            }}
            renderValue={() => (
                <PrioritySelectorItem text={currentPriority.text} color={currentPriority.color} />
            )}
            >
            <MenuItem value={0}>
                <PrioritySelectorItem />
            </MenuItem>
            {priorities.map(({ id, color, text }) => (
                <MenuItem value={id} key={id.toString()}>
                    <PrioritySelectorItem color={color} text={text} />
                </MenuItem>
            ))}
            </Select>
        </StyledFormControl>
        );
    };
    
    const FlexibleSpace = (({
        priority, priorityChange, ...restProps
    }: any) => (
        <StyledToolbarFlexibleSpace {...restProps} className={classes.flexibleSpace}>
            <PrioritySelector priority={priority} priorityChange={priorityChange} />
        </StyledToolbarFlexibleSpace>
    ));
    // SHIFT EVENT
    const TooltipHeader = ({ appointmentData, onOpen, toggleVisible, deleteItem }: any) => {
        return (
            <StyledTooltipHeader
            >
                <div className={classNames(classes.header, classes.buttonGroup, classes.wrapper)}>
                    <IconButton className={classes.closeButton} onClick={() => onOpen(appointmentData)} size="medium">
                        {/* <Edit className={classes.icon} /> */}
                        <Edit />
                    </IconButton>
                    <IconButton className={classes.closeButton} onClick={() => deleteItem(appointmentData, true)} size="medium">
                        {/* <Delete className={classes.icon} /> */}
                        <Delete />
                    </IconButton>
                    <IconButton className={classes.closeButton} onClick={toggleVisible} size="medium">
                        {/* <Close className={classes.icon} /> */}
                        <Close />
                    </IconButton>
                </div>
            </StyledTooltipHeader>
            // <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
            //   <strong>{appointmentData.title}</strong>
            //   <Button onClick={() => onOpen(appointmentData)} variant="outlined" size="small">
            //     Ouvrir
            //   </Button>
            // </div>
      );
    };
    const TooltipContent = ({
        appointmentData, formatDate, appointmentResources
    // #FOLD_BLOCK
    }: any) => {
        const resource = appointmentResources[0];
        let icon = <LowPriority className={classes.icon} />;
        if (appointmentData.priorityId === 2) {
            icon = <Event className={classes.icon} />;
        }
        if (appointmentData.priorityId === 3) {
            icon = <PriorityHigh className={classes.icon} />;
        }
        return (
        <StyledTooltipContent className={classes.content} color={resource.color}>
            <Grid container alignItems="flex-start" className={classes.titleContainer}>
            <Grid item xs={2} className={classNames(classes.textCenter)}>
                {/* <Lens className={classNames(classes.lens, classes.colorfulContent)} /> */}
                { appointmentData.userId !== PUBLIC_ID &&
                    appointmentData.user.image ?
                        <UserImage user={appointmentData.user} customClass="coworker_mini shadow-sm hover:shadow-md" key={"worker_" + appointmentData.userId} />
                        // <Image src={`https://amplify-schedulum-4nkh-sa-schedulumdrivebucket775c-j6met6z19khi.s3.us-east-1.amazonaws.com/public/${appointmentData.user.image}`} width="50" height="50" roundedCircle />
                    :
                        <Image src="/no-avatar.jpg" width="50" height="50" roundedCircle />    
                }
            </Grid>
            <Grid item xs={10}>
                <div>
                <div className={classNames(classes.title, classes.dateAndTitle)}>
                    {/* { appointmentData.user ?
                        <UserImage user={appointmentData.user} />
                        :
                        <img src="/no-avatar.jpg" style={{width:100, height:100}}/>
                    } */}
                    {appointmentData.role}
                </div>
                <div className={classNames(classes.title, classes.dateAndTitle)} style={{fontWeight: "normal"}}>
                    {appointmentData.location}
                </div>
                <div className={classNames(classes.text, classes.dateAndTitle)}>
                    {formatDate(appointmentData.startDate, { day: 'numeric', weekday: 'long' })}
                </div>
                </div>
            </Grid>
            </Grid>
            <Grid container alignItems="center" className={classes.contentContainer}>
            <Grid item xs={2} className={classes.textCenter}>
                <AccessTime className={classes.icon} />
            </Grid>
            <Grid item xs={10}>
                <div className={classes.text}>
                {`${formatDate(appointmentData.startDate, { hour: 'numeric', minute: 'numeric' })}
                    - ${formatDate(appointmentData.endDate, { hour: 'numeric', minute: 'numeric' })}`}
                </div>
            </Grid>
            </Grid>
            <Grid container alignItems="center" key={`${resource.fieldName}_${resource.id}`}>
            <Grid
                className={classNames(classes.contentItemIcon, classes.icon, classes.colorfulContent)}
                item
                xs={2}
            >
                {icon}
            </Grid>
            <Grid item xs={10}>
                <span className={classNames(classes.text, classes.colorfulContent)}>
                {resource.text}
                </span>
                {/* <div>
                    <Button onClick={() => onOpen(appointmentData)}>Ouvrir</Button>
                </div> */}
            </Grid>
            </Grid>
        </StyledTooltipContent>
        );
    };
    // AppointmentForm
    const StyledDiv = styled('div')(({ theme }) => ({
        [`& .${classes.icon}`]: {
        margin: theme.spacing(2, 0),
        marginRight: theme.spacing(2),
        },
        [`& .${classes.header}`]: {
        overflow: 'hidden',
        paddingTop: theme.spacing(0.5),
        },
        [`& .${classes.textField}`]: {
        width: '100%',
        },
        [`& .${classes.content}`]: {
        padding: theme.spacing(2),
        paddingTop: 0,
        },
        [`& .${classes.closeButton}`]: {
        float: 'right',
        },
        [`& .${classes.picker}`]: {
        marginRight: theme.spacing(2),
        '&:last-child': {
            marginRight: 0,
        },
        width: '50%',
        },
        [`& .${classes.wrapper}`]: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1, 0),
        },
        [`& .${classes.buttonGroup}`]: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 2),
        },
        [`& .${classes.button}`]: {
        marginLeft: theme.spacing(2),
        },
    }));
    const StyledFab = styled(Fab)(({ theme }) => ({
        [`&.${classes.addButton}`]: {
        position: 'absolute',
        bottom: theme.spacing(3),
        right: theme.spacing(4),
        },
    }));
    // class AppointmentFormContainerBasic extends PureComponent {
    const AppointmentFormContainerBasic = ({
        appointmentData, formatDate, appointmentResources, visible, visibleChange, 
        cancelAppointment, target, onHide, commitChanges
    // #FOLD_BLOCK
    }: any) => {
    
        const [state, setState] = useState({
            appointmentChanges: {},
        });
        // constructor(props) {
        //   super(props);
    
        //   this.state = {
        //     appointmentChanges: {},
        //   };
    
        //   this.getAppointmentData = () => {
        //     const { appointmentData } = this.props;
        //     return appointmentData;
        //   };
        //   this.getAppointmentChanges = () => {
        //     const { appointmentChanges } = this.state;
        //     return appointmentChanges;
        //   };
    
        //   this.changeAppointment = this.changeAppointment.bind(this);
        //   this.commitAppointment = this.commitAppointment.bind(this);
        // }
    
        const getAppointmentChanges = () => {
            const { appointmentChanges } = state;
            return appointmentChanges;
        };
    
        const changeAppointment = ({ field, changes }: any) => {
        const nextChanges = {
            ...getAppointmentChanges(),
            [field]: changes,
        };
        setState((prevState) => ({...prevState,
            appointmentChanges: nextChanges,
        }));
        }
    
        const commitAppointment = (type: any) => {
        // const { commitChanges } = this.props;
        // console.log('type', type);
        const appointment = {
            ...appointmentData,
            ...getAppointmentChanges(),
        };
        if (type === 'deleted') {
            commitChanges({ [type]: appointmentData.id });//appointment.id });
        } else if (type === 'changed') {
            commitChanges({ [type]: { [appointmentData.id] : appointment }}); //[appointment.id]: appointment } });
        } else {
            commitChanges({ [type]: appointment });
        }
        setState((prevState) => ({...prevState,
            appointmentChanges: {},
        }));
        }
    
        const displayAppointmentData = {
            ...appointmentData,
            ...state,
            // ...appointmentChanges,
        };
        const isNewAppointment = appointmentData.id === undefined;
        const applyChanges = isNewAppointment
            ? () => commitAppointment('added')
            : () => commitAppointment('changed');
    
        const textEditorProps = (field: any) => ({
            variant: 'outlined' as 'outlined',
            onChange: ({ target: change }: any) => changeAppointment({
                field: [field], changes: change.value,
            }),
            value: displayAppointmentData[field] || '',
            label: field[0].toUpperCase() + field.slice(1),
            className: classes.textField,
        });
    
        const pickerEditorProps = (field: any) => ({
            // keyboard: true,
            value: displayAppointmentData[field],
            onChange: (date: any) => changeAppointment({
                field: [field], changes: date ? date.toDate() : new Date(displayAppointmentData[field]),
            }),
            ampm: false,
            inputFormat: 'DD/MM/YYYY HH:mm',
            onError: (): null => null,
        });
    
        const startDatePickerProps = pickerEditorProps('startDate');
        const endDatePickerProps = pickerEditorProps('endDate');
    
        const cancelChanges = () => {
            setState((prevState) => ({...prevState,
                appointmentChanges: {},
            }));
            visibleChange();
            cancelAppointment();
        };
        return (
            <AppointmentForm.Overlay
                visible={visible}
                target={target}
                fullSize
                onHide={onHide}
                >
                <StyledDiv>
                    <div className={classes.header}>
                    <IconButton className={classes.closeButton} onClick={cancelChanges} size="large">
                        <Close color="action" />
                    </IconButton>
                    </div>
                    <div className={classes.content}>
                    <div className={classes.wrapper}>
                        <Create className={classes.icon} color="action" />
                        <TextField
                        {...textEditorProps('title')}
                        
                        />
                    </div>
                    <div className={classes.wrapper}>
                        <CalendarToday className={classes.icon} color="action" />
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DateTimePicker
                            label="Start Date"
                            renderInput={
                            props => <TextField className={classes.picker} {...props} />
                            }
                            {...startDatePickerProps}
                        />
                        <DateTimePicker
                            label="End Date"
                            renderInput={
                            props => <TextField className={classes.picker} {...props} />
                            }
                            {...endDatePickerProps}
                        />
                        </LocalizationProvider>
                    </div>
                    <div className={classes.wrapper}>
                        <LocationOn className={classes.icon} color="action" />
                        <TextField
                        {...textEditorProps('location')}
                        />
                    </div>
                    <div className={classes.wrapper}>
                        <Notes className={classes.icon} color="action" />
                        <TextField
                        {...textEditorProps('notes')}
                        multiline
                        rows="6"
                        />
                    </div>
                    </div>
                    <div className={classes.buttonGroup}>
                    {!isNewAppointment && (
                        <Button
                        variant="outlined"
                        color="secondary"
                        className={classes.button}
                        onClick={() => {
                            visibleChange();
                            commitAppointment('deleted');
                        }}
                        >
                        Delete
                        </Button>
                    )}
                    <Button
                        variant="outlined"
                        color="primary"
                        className={classes.button}
                        onClick={() => {
                        visibleChange();
                        applyChanges();
                        }}
                    >
                        {isNewAppointment ? 'Create' : 'Save'}
                    </Button>
                    </div>
                </StyledDiv>
            </AppointmentForm.Overlay>
        );
    
        // render() {
        //   const {
        //     visible,
        //     visibleChange,
        //     appointmentData,
        //     cancelAppointment,
        //     target,
        //     onHide,
        //   } = this.props;
        //   const { appointmentChanges } = this.state;
    
        //   const displayAppointmentData = {
        //     ...appointmentData,
        //     ...appointmentChanges,
        //   };
    
        //   const isNewAppointment = appointmentData.id === undefined;
        //   const applyChanges = isNewAppointment
        //     ? () => this.commitAppointment('added')
        //     : () => this.commitAppointment('changed');
    
        //   const textEditorProps = field => ({
        //     variant: 'outlined',
        //     onChange: ({ target: change }) => this.changeAppointment({
        //       field: [field], changes: change.value,
        //     }),
        //     value: displayAppointmentData[field] || '',
        //     label: field[0].toUpperCase() + field.slice(1),
        //     className: classes.textField,
        //   });
    
        //   const pickerEditorProps = field => ({
        //     // keyboard: true,
        //     value: displayAppointmentData[field],
        //     onChange: date => this.changeAppointment({
        //       field: [field], changes: date ? date.toDate() : new Date(displayAppointmentData[field]),
        //     }),
        //     ampm: false,
        //     inputFormat: 'DD/MM/YYYY HH:mm',
        //     onError: () => null,
        //   });
        //   const startDatePickerProps = pickerEditorProps('startDate');
        //   const endDatePickerProps = pickerEditorProps('endDate');
        //   const cancelChanges = () => {
        //     this.setState({
        //       appointmentChanges: {},
        //     });
        //     visibleChange();
        //     cancelAppointment();
        //   };
    
        //   return (
        //     <AppointmentForm.Overlay
        //       visible={visible}
        //       target={target}
        //       fullSize
        //       onHide={onHide}
        //     >
        //       <StyledDiv>
        //         <div className={classes.header}>
        //           <IconButton className={classes.closeButton} onClick={cancelChanges} size="large">
        //             <Close color="action" />
        //           </IconButton>
        //         </div>
        //         <div className={classes.content}>
        //           <div className={classes.wrapper}>
        //             <Create className={classes.icon} color="action" />
        //             <TextField
        //               {...textEditorProps('title')}
        //             />
        //           </div>
        //           <div className={classes.wrapper}>
        //             <CalendarToday className={classes.icon} color="action" />
        //             <LocalizationProvider dateAdapter={AdapterMoment}>
        //               <DateTimePicker
        //                 label="Start Date"
        //                 renderInput={
        //                   props => <TextField className={classes.picker} {...props} />
        //                 }
        //                 {...startDatePickerProps}
        //               />
        //               <DateTimePicker
        //                 label="End Date"
        //                 renderInput={
        //                   props => <TextField className={classes.picker} {...props} />
        //                 }
        //                 {...endDatePickerProps}
        //               />
        //             </LocalizationProvider>
        //           </div>
        //           <div className={classes.wrapper}>
        //             <LocationOn className={classes.icon} color="action" />
        //             <TextField
        //               {...textEditorProps('location')}
        //             />
        //           </div>
        //           <div className={classes.wrapper}>
        //             <Notes className={classes.icon} color="action" />
        //             <TextField
        //               {...textEditorProps('notes')}
        //               multiline
        //               rows="6"
        //             />
        //           </div>
        //         </div>
        //         <div className={classes.buttonGroup}>
        //           {!isNewAppointment && (
        //             <Button
        //               variant="outlined"
        //               color="secondary"
        //               className={classes.button}
        //               onClick={() => {
        //                 visibleChange();
        //                 this.commitAppointment('deleted');
        //               }}
        //             >
        //               Delete
        //             </Button>
        //           )}
        //           <Button
        //             variant="outlined"
        //             color="primary"
        //             className={classes.button}
        //             onClick={() => {
        //               visibleChange();
        //               applyChanges();
        //             }}
        //           >
        //             {isNewAppointment ? 'Create' : 'Save'}
        //           </Button>
        //         </div>
        //       </StyledDiv>
        //     </AppointmentForm.Overlay>
        //   );
        // }
    }
    return {
        DayViewTimeTableCell, DayViewDayScaleCell, WeekViewTimeTableCell, WeekViewDayScaleCell, AllDayCell, GroupingPanelCell, PrioritySelector, FlexibleSpace, TooltipContent, TooltipHeader, AppointmentFormContainerBasic, 
    }
    // PrioritySelectorItem // needed inside
};

export default useSchedulerItems;